export const getHrefUrl = (parameter) => {
  const data = btoa(parameter);
  const domain = process.env.REACT_APP_BASE_API_URL;
  return `${domain}BillOfLading/Print?data=${data}`;
};
